// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CookieDeclarationSection_wrapper__q8Vpf"};